<template>
  <button
    :aria-label="props.title"
    :aria-selected="props.group === props.activeGroupRef.value"
    class="btn btn-default sidepanel-toolbar-button relative"
    ref="element"
    role="tab"
    :tabindex="props.group === props.activeGroupRef.value || (activeGroupRef.value === null && props.index === 0) ? 0 : -1"
    :title="props.title"
    type="button"
    @click="clickOrUpsell()"
    @keyup.up="goto(props.index - 1)"
    @keyup.down="goto(props.index + 1)"
  >
    <span v-if="typeof props.icon === 'function'" v-html="props.icon()"></span>
    <BaseIcon v-else class="bi-18" :iconName="props.icon" @load="props.onIconLoad"/>
    <BaseIcon v-if="triggersUpsell" class="bi-16 upsell-icon" :iconName="upsellIcon"/>
  </button>
</template>

<script setup>
import { ref } from 'vue'
import BaseIcon from '@/io.ox/vueComponents/base-icon.vue'
import upsell from '@/io.ox/core/upsell'

const props = defineProps({
  activeGroupRef: { type: Object, required: true },
  icon: { type: [String, Function], default: 'bi/emoji-smile-fill.svg' },
  index: { type: Number, default: 100 },
  group: { type: String, default: 'n/a' },
  onClick: { type: Function, default: () => {} },
  onIconLoad: { type: Function, default: () => {} },
  requires: { type: String, default: '' },
  title: { type: String, required: true },
})

const element = ref(null)
const triggersUpsell = Boolean(props.requires && upsell.wouldTriggerUpsell(props.requires))
const upsellIcon = upsell.getDefaultIcon()

function goto (index) {
  const buttons = [...element.value.parentElement.children]
    .filter(({ tagName }) => tagName === 'BUTTON')
  const el = buttons.at(index % buttons.length)
  el.focus()
}

function clickOrUpsell () {
  if (triggersUpsell) upsell.trigger({ type: 'custom', id: `sidepanel/${props.group}`, missing: props.requires })
  else props.onClick()
}

</script>

<style scoped>
.sidepanel-toolbar-button[aria-selected="true"],
.sidepanel-toolbar-button[aria-selected="true"]:focus {
  background-color: var(--selected-background);
}
.upsell-icon {
  position: absolute;
  color: var(--upsell);
  top: 0;
  right: 0;
}
</style>
